import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
// import { Outlet } from "react-router-dom";
import Sidebar, { SidebarForUser } from "./sidebar";
import Header from "./header";
import "../../App.css";
import { fetchUserAllowedRoutes, getBussinessData } from "../../store/actions/action";
import { BusinessSettingsProvider } from "./BusinessSettingsContext";

export default function Layout({ children }) {
  const { bussinessUuid } = useParams();
  const dispatch = useDispatch();
  const businessData = useSelector((state) => state.bussiness?.business);
  const business = Array.isArray(businessData) ? businessData.find((b) => b.bussinessUuid === bussinessUuid) : businessData;
  const businessLoadedUuid = business?.bussinessUuid;

  useEffect(() => {
    // If we have a bussinessUuid from URL but business data is not in store, fetch it
    if (bussinessUuid && !businessLoadedUuid) {
      dispatch(getBussinessData(bussinessUuid));
    }
  }, [dispatch, bussinessUuid, businessLoadedUuid]);

  useEffect(() => {
    // Fetch user allowed routes once we have the business UUID
    if (bussinessUuid) {
      dispatch(fetchUserAllowedRoutes(bussinessUuid));
    }
  }, [dispatch, bussinessUuid]);

  return (
    <BusinessSettingsProvider businessUuid={bussinessUuid}>
      <div className='h-screen w-screen flex flex-row overflow-hidden-important '>
        <Sidebar />
        <div className='flex flex-col flex-1 overflow-hidden'>
          <Header />

          <div
            className='bg-blue-50 dark:bg-[#020617] dark:text-white overflow-auto scroll-w-6 sm:w-full overflow-auto flex-1 
            min-h-0 '
          >
            {children}
          </div>
        </div>
      </div>
    </BusinessSettingsProvider>
  );
}

export const LayoutforUser = ({ children }) => {
  return (
    <div className='h-screen w-screen overflow-hidden flex flex-row'>
      <SidebarForUser />
      <div className='flex flex-col flex-1'>
        {/* <Header /> */}
        <div className='bg-gray-50 flex-1 p-4 min-h-0 overflow-auto '>
          {children}
        </div>
      </div>
    </div>
  );
};
